export const isUndefined = value => value === undefined;

// Added this function because the react-ga4 library uses undefined values to check existence of parameters
export const returnOrUndefined = (value, condition) => (condition ? value : undefined);
